<!-- Internal dropdown -->
<ng-container *ngIf="isInternalSelection">
  <mat-form-field appearance="fill" style="width: 100%">
    <mat-label>{{ dropDown.label }}</mat-label>
    <mat-select
      [formControl]="control"
      (selectionChange)="onSelectionChange($event.value)"
    >
      <mat-option *ngFor="let item of items" [value]="item.value">
        {{ item.value }}
      </mat-option>
    </mat-select>

    <!-- Required error -->
    <mat-error *ngIf="control.hasError('required') && control.touched">
      {{ dropDown.label }}&nbsp;{{
        'workflow.request-document.basic-details.required-error' | translate
      }}
    </mat-error>
  </mat-form-field>
</ng-container>

<!-- External dropdown placeholder -->
<ng-container *ngIf="isExternalSelection">
  <mat-form-field appearance="fill" style="width: 100%">
    <mat-label>{{ dropDown.label }}</mat-label>

    <input
      type="text"
      placeholder="{{ dropDown.placeholder }}"
      matInput
      [(ngModel)]="externalDisplayValue"
      (ngModelChange)="onDisplayValueChange($event)"
      [matAutocomplete]="ExternalReference"
    />
    <mat-icon matSuffix class="custom-arrow-icon"> arrow_drop_down </mat-icon>
    <mat-autocomplete
      autoActiveFirstOption
      #ExternalReference="matAutocomplete"
      (optionSelected)="ExternalReferenceAction($event.option.value)"
    >
      <mat-option
        *ngFor="let section of filteredExternalOptions"
        [value]="section.displayValue"
      >
        {{ section.displayValue }}
      </mat-option>
    </mat-autocomplete>

    <mat-error *ngIf="control.hasError('required') && control.touched">
      {{ dropDown.label }}&nbsp;{{
        'workflow.request-document.basic-details.required-error' | translate
      }}
    </mat-error>
  </mat-form-field></ng-container
>
